import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    url; // 图片路径
    persons;
    blurSize; // 模糊尺寸
    fit; // 图片填充方式： fill / contain / cover / none / scale-down
    // @Prop({ type: Boolean, default: false }) readonly lazy!: boolean; // 是否开启懒加载
    layer; // 是否绘制叠框
    get computedStyle() {
        const blurSize = this.failed ? 0 : this.blurSize;
        return {
            '-webkit-filter': `blur(${blurSize / 10}rem)`,
            '-moz-filter': `blur(${blurSize / 10}rem)`,
            '-ms-filter': `blur(${blurSize / 10}rem)`,
            filter: `blur(${blurSize / 10}rem)`,
        };
    }
    imgLoad;
    loading = true;
    failed = false;
    onLayerChange() {
        this.drawFace();
    }
    mounted() {
        this.imgLoad = new Promise((resolve, reject) => {
            let img = new Image();
            img.crossOrigin = '';
            img.src = this.url;
            img.onload = () => {
                resolve(img);
            };
            img.onerror = () => {
                reject(img);
            };
        });
        this.drawFace();
    }
    Point(x, y) {
        return { x: x, y: y };
    }
    drawFace() {
        // const drawRectOption = { lineColor: colors.white, fillColor: colors.white, weight: 2, opacity: 0.5 };
        this.imgLoad
            .then((img) => {
            const canvas = this.$refs.mycanvas;
            if (!canvas) {
                return false;
            }
            // 可以理解为一个画笔，可画路径、矩形、文字、图像
            const context = canvas.getContext('2d');
            // 加载图片
            if (img.complete) {
                // 根据图像重新设定了canvas的长宽
                // 绘制图片
                const { height, width } = img;
                const parent = document.querySelector('.set-active-item');
                const parentStyle = {
                    width: parent.offsetWidth,
                    height: parent.offsetHeight,
                };
                // fill 模式
                if (width / height > parentStyle.width / parentStyle.height) {
                    canvas.style.width = '100%';
                }
                else {
                    canvas.style.height = '100%';
                }
                canvas?.setAttribute('width', String(width));
                canvas?.setAttribute('height', String(height));
                context?.drawImage(img, 0, 0, width, height); // 画布大小
                // context.strokeStyle = colors.white; // 矩形线颜色
                const imageData = this.persons;
                if (imageData && this.layer) {
                    imageData.forEach((vertices) => {
                        if (vertices.type === 'rect') {
                            context.lineWidth = 5;
                            context.strokeStyle = colors.lineFillStyle;
                            context.fillStyle = 'transparent';
                        }
                        else {
                            context.lineWidth = 0.01;
                            context.strokeStyle = colors.white;
                            context.fillStyle = 'transparent';
                        }
                        // console.log()
                        const coordinates = vertices;
                        const x = coordinates.vertices[0].x;
                        const y = coordinates.vertices[0].y;
                        const rightX = coordinates.vertices[1].x - x;
                        const rightY = coordinates.vertices[1].y - y;
                        const startX = x * width;
                        const startY = y * height;
                        const endX = Math.abs(rightX * width);
                        const endY = Math.abs(rightY * height);
                        context?.strokeRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                        context?.fillRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                        context.stroke();
                        let rectWidth = Math.max(12, endX * 0.2, endY * 0.2);
                        rectWidth = Math.min(rectWidth, 35);
                        const rectHeight = 5;
                        if (vertices.type === 'rect') {
                            return;
                        }
                        // 绘制4个直角;
                        context.fillStyle = colors.white;
                        context.fillRect(startX, startY, rectWidth, rectHeight);
                        context.fillRect(startX, startY, rectHeight, rectWidth);
                        context.fillRect(startX, startY + endY - rectWidth, rectHeight, rectWidth);
                        context.fillRect(startX, startY + endY - rectHeight, rectWidth, rectHeight);
                        context.fillRect(startX + endX - rectWidth, startY, rectWidth, rectHeight);
                        context.fillRect(startX + endX - rectHeight, startY, rectHeight, rectWidth);
                        context.fillRect(startX + endX - rectHeight, startY + endY - rectWidth, rectHeight, rectWidth);
                        context.fillRect(startX + endX - rectWidth, startY + endY - rectHeight, rectWidth, rectHeight);
                    });
                }
            }
        })
            .catch(() => {
            this.failed = true;
        })
            .finally(() => {
            this.loading = false;
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "url", void 0);
__decorate([
    Prop()
], default_1.prototype, "persons", void 0);
__decorate([
    Prop({ type: Number, default: 6 })
], default_1.prototype, "blurSize", void 0);
__decorate([
    Prop({ type: String, default: 'contain' })
], default_1.prototype, "fit", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], default_1.prototype, "layer", void 0);
__decorate([
    Watch('layer')
], default_1.prototype, "onLayerChange", null);
default_1 = __decorate([
    Component({
        name: 'SnapPicture',
        components: {},
        i18n: {
            messages: {
                zh: {
                    failed: '加载失败',
                },
                en: {
                    failed: 'FAILED',
                },
            },
        },
    })
], default_1);
export default default_1;
